export const DAY = 24 * 3600 * 1000

/** Номер дня с начала эпохи в местном поясе — так же, как хранит Android. */
export function epochDayOf(millis: number): number {
  const date = new Date(millis)
  return Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / DAY)
}
